import * as React from 'react';
import { FooterNavigationItem, FooterProps } from './models';

import './styles.scss';


export const Footer: React.FC<FooterProps> = ({ data }) => {
   const showEvidonOptions = () => {
    const win = window as any;
    if (win.evidon && win.evidon.notice && typeof win.evidon.notice.showOptions === 'function') {
      win.evidon.notice.showOptions.call(win.evidon.notice);
    }
  };

  const handleEvidonClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    if ('key' in e && e.key !== 'Enter') {
      return;
    }
    e.preventDefault();
    showEvidonOptions();
  };
  if (!data) {
    return null;
  }

  const {
    id,
    linkLogoImageToHomepage,
    logoImageHomepageLink,
    logoReference,
    footerNavigationItems,
    topLeftColumnText,
    topCenterColumnText,
    topRightColumnText,
    bottomLeftColumnText,
    bottomRightColumnText,
    cookiePreferencesText
  } = data;

  // Resolve logo URL using Dynamic Media (serverPath + assetPath)
  const getLogoUrl = () => {
    if (typeof logoReference === 'string' && logoReference.startsWith('/images/')) {
      return logoReference;
    }
    if (logoReference && typeof logoReference === 'object' && logoReference !== null) {
      const assetName = (logoReference as any).assetName;
      return assetName.startsWith('/images/') ? assetName : '/images/gehealthcarestage/' + assetName;
    }
    return '';
  };

  const handleLanguageLinkClick = () => {
    if (data.countrySelector?.countryUrl) {
      // Open the sitemap in a new tab
      window.open(data.countrySelector.countryUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer className="ge-footer" id={id}>
      {(logoReference || (footerNavigationItems && footerNavigationItems.length > 0) ||
        topLeftColumnText || topCenterColumnText || topRightColumnText ||
        data.countrySelector) && (
          <div className="ge-footer-top">
            <div className="ge-footer-top-content">
              {(logoReference || (footerNavigationItems && footerNavigationItems.length > 0)) && (
                <div className="ge-footer-top-content-core-items">
                  {logoReference && (
                    <div className="ge-footer-top-content-core-items-logo">
                      {linkLogoImageToHomepage && logoImageHomepageLink ? (
                        <a
                          href={logoImageHomepageLink}
                          aria-label="GE Logo"
                        >
                          <img
                            className="site-logo__image"
                            src={getLogoUrl()}
                            alt="GE Logo"
                          />
                        </a>
                      ) : (
                        <img
                          alt="GE Logo"
                          className="site-logo__image"
                          src={getLogoUrl()}
                        />
                      )}
                    </div>
                  )}
                  {footerNavigationItems && footerNavigationItems.length > 0 && (
                    <div className="ge-footer-top-content-core-items-utility">
                      {footerNavigationItems.map((item: FooterNavigationItem) => (
                        <a
                          key={`footer-nav-${item.path}-${item.textLabel}`}
                          href={item.path}
                          className="ge-link ge-footer-top-content-core-items-utility-link caption"
                          target={item.urlTarget}
                        >
                          {item.textLabel}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {(topLeftColumnText || topCenterColumnText || topRightColumnText) && (
                <div className="ge-company-details">
                  <div className="company-detail-wrapper">
                    <div className="details company-address">
                      {topLeftColumnText && (
                        <div className="detail-1">
                          <div
                            className="ge-company-details--text"
                            dangerouslySetInnerHTML={{ __html: topLeftColumnText }}
                          />
                        </div>
                      )}
                      <div className="detail-2">
                        <div className="ge-company-details--text">
                          {topCenterColumnText && (<span
                            className="ge-company-details--contacts"
                            dangerouslySetInnerHTML={{ __html: topCenterColumnText }}
                          />)}
                        </div>
                      </div>
                      <div className="detail-3">
                        <div className="ge-company-details--text">
                          {topRightColumnText && (<span
                            className="ge-company-details--people"
                            dangerouslySetInnerHTML={{ __html: topRightColumnText }}
                          />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {data.countrySelector && (
                <div className="ge-footer-top-content-country-social-links">
                  <div className="ge-footer-top-content-country-social-links-child">
                    <div className="ge-location-selector__wrap">
                      {data.countrySelector.countryUrl && (
                        <button className="language-link" type="button" onClick={handleLanguageLinkClick}>
                          {data.countrySelector?.countryIcon && (
                            <span className="cmp-button__icon" dangerouslySetInnerHTML={{ __html: data.countrySelector.countryIcon }}>
                            </span>
                          )}
                          <span
                            className="language-link-location text-paragraph-s"
                          >
                            China
                          </span>
                          {data.countrySelector?.caretIcon && (
                            <span className="language-link-caret cmp-button__icon" dangerouslySetInnerHTML={{ __html: data.countrySelector.caretIcon }} />
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      {(bottomLeftColumnText || bottomRightColumnText) && (
        <div className="ge-footer-bottom">
          <div className="ge-footer-bottom-content">
            <div className="ge-footer-bottom-content-legal-terms">
              {bottomLeftColumnText && (
                <div className="ge-footer-bottom-content-legal-terms-child disclaimer">
                  <div dangerouslySetInnerHTML={{ __html: bottomLeftColumnText }} />
                </div>
              )}
              {bottomRightColumnText && (
                <div className="ge-footer-bottom-content-legal-terms-child">
                  <a role="button" tabIndex={0} className="evidon-cookie-link" onClick={handleEvidonClick} onKeyDown={handleEvidonClick}>
                    <span id="_evidon-link-text" className="evidon-cookie-link-text">{cookiePreferencesText}</span>
                  </a>
                  <div
                    className="ge-footer-bottom-content-legal-terms-links-wrapper"
                    dangerouslySetInnerHTML={{ __html: bottomRightColumnText }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
